import { Col, FormGroup, Label, Row } from "reactstrap";
import { UploadProjectFiles } from "../../../../utils/Constant";
import CommonFileUpload from "../../../Common/CommonFileUpload";

const UploadProjectFile = () => {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>{UploadProjectFiles}</Label>
          <CommonFileUpload multiple />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default UploadProjectFile;
